<template>
	<div>
		<div class="ask f-cb">
			<div class="ask-avatar f-img-box" @click="$router.push('/other/history/'+data.user_id)">
				<img :src="data.avatar?data.avatar:studentAvatar">
			</div>
			<div class="ask-content">
				<div class="ask-from o1">源自：{{data.section_title}}</div><!--源自：第02章·01节-->
				<div class="ask-title">{{data.title}}</div>
				<div class="ask-text" v-html="data.content"></div>
				<div class="ask-info f-cb">
					<div class="ask-info-1">回答<span>{{answers.length}}</span></div>
					<!--<div class="ask-info-2">浏览<span>346</span></div>-->
					<div class="ask-info-button" v-if="this.$store.state.isLogin" @click="isAnswerDialogShow=true">我来回答</div>
				</div>
			</div>
		</div>
		<div class="answer">
			<ul class="answer-items" v-dt-infinite-scroll="getData">
				<!--<li class="answer-item f-cb">
					<div class="answer-avatar f-img-box">
						<img src="../index/teacher.png">
					</div>
					<div class="answer-content">
						<div class="answer-name">姓名</div>
						<div class="answer-text">么样效率比较高？老师，请问怎么样效率比较高？老师，请问怎么样效率比较高？老师，请问怎么样效率比较高？老师，请问怎么样效率比较高？老师，请问怎么样效率比较高？老师，请问怎么样效率比较高？老师，请问怎么样效率</div>
						<div class="answer-info f-cb">
							<div class="answer-time">2小时前</div>
							<div class="answer-button">回复</div>
						</div>
						<div class="answer-reply">
							<ul class="answer-reply-items">
								<li class="answer-reply-item"><span>淘气的棉花糖：</span>老师，请问怎么样效率比较高老师，请问怎么样效率比较高</li>
								<li class="answer-reply-item"><span>淘气花糖：</span>谢谢</li>
							</ul>
						</div>
					</div>
				</li>-->
				<li class="answer-item f-cb" v-for="item in answers">
					<div class="answer-avatar f-img-box" @click="$router.push('/other/history/'+item.user_id)">
						<img :src="item.avatar?item.avatar:studentAvatar">
					</div>
					<div class="answer-content">
						<div class="answer-name" @click="$router.push('/other/history/'+item.user_id)">{{item.nick_name}}</div>
						<div class="answer-text">{{item.content}}</div>
						<div class="answer-info f-cb">
							<!--<div class="answer-time"></div>-->
							<!--<div class="answer-button">回复</div>-->
						</div>
						<!--<div class="answer-reply">
							<ul class="answer-reply-items">
								<li class="answer-reply-item"><span>淘气的棉花糖：</span>老师，请问怎么样效率比较高老师，请问怎么样效率比较高</li>
								<li class="answer-reply-item" v-for="value in item.children"><span>{{value.nick_name}}：</span>{{value.content}}</li>
							</ul>
						</div>-->
					</div>
				</li>
			</ul>
		</div>
		<dialog-mask :open="isAnswerDialogShow">
			<div class="reply-dialog">
				<div class="reply-dialog-line f-cb">
					<!--<div class="reply-dialog-text">回复 会跳的毛毛虫</div>-->
					<div class="reply-dialog-close" @click="isAnswerDialogShow=false">×</div>
				</div>
				<div class="reply-dialog-area">
					<textarea placeholder="请在这里输入回复内容..." v-model="answerContent"></textarea>
				</div>
				<!--<div class="reply-dialog-num">0/200</div>-->
				<div class="reply-dialog-button">
					<button type="button" @click="submitAnswer">确定</button>
				</div>
			</div>
		</dialog-mask>
	</div>
</template>

<script>
	import mask from "../mask/mask.vue"
	export default{
		data(){
			return{
				answers:[],
				data:{},
				isAnswerDialogShow:false,
				answerContent:""
			}
		},
		created(){
      //获取问题
      this.$api.get("",{
        api:"/v1/question_answer/read1",
        question_id:this.$route.params.id,
        len:1,
        page:1
      },(res)=>{
        var data=res.data;
        // this.answers=data.answers;
        this.data=data.question;
      })
		},
		methods:{
			getData(page){
			  var length=10;
			  return new Promise((resolve,reject)=>{
          this.$api.get("",{
            api:"/v1/question_answer/read1",
            question_id:this.$route.params.id,
            page,
            len:length
          },(res)=>{
            var data=res.data.answers;
            this.answers=this.answers.concat(data);
            if(data.length<length){
              reject();
            }
            else{
              resolve();
            }
          })
        })
			},
			submitAnswer(){
				this.$api.get("",{
					api:"/v1/question_answer/create_answer",
					question_id:this.$route.params.id,
					user_type:this.tools.getStorage("user_type"),
					content:this.answerContent
				},(res)=>{
          if(res.status==1){
            this.$toast("回答成功");
            this.answerContent="";
            this.isAnswerDialogShow=false;
          }else{
            this.$toast(res.msg);
          }

				})
			}
		},
		components:{
			"dialog-mask":mask
		}
	}
</script>

<style>
	.ask{
		padding:0.533rem 0.4rem 0.4rem 0.4rem;
		background: #fff;
	}
	.ask-avatar{
		float:left;
		overflow: hidden;
		width:1.2rem;
		height:1.2rem;
		border-radius: 50%;
	}
	.ask-content{
		float:right;
		width:7.733rem;
	}
	.ask-content img{
		max-width: 100%!important;
	}
	.ask-from{
		font-size: 0.266rem;
		color:#999;
	}
	.ask-title{
		margin-top:0.186rem;
		font-size: 0.426rem;
		line-height:0.64rem;
		color:#333;
	}
	.ask-text{
		margin-top:0.053rem;
		font-size: 0.346rem;
		line-height: 0.506rem;
		color:#666;
	}
	.ask-info{
		margin-top: 0.213rem;
		line-height: 0.586rem;
	}
	.ask-info-1,
	.ask-info-2{
		float:left;
		font-size: 0.266rem;
		color:#999;
	}
	.ask-info-1 span,
	.ask-info-2 span{
		margin-left:0.266rem;
	}
	.ask-info-2{
		margin-left: 0.786rem;
	}
	.ask-info-button{
		float:right;
		width:1.706rem;
		height:0.586rem;
		background: #ec6d3a;
		line-height: 0.586rem;
		text-align: center;
		color:#fff;
		border-radius: 0.133rem;
	}
	.answer-item{
		margin:0 0.4rem;
		padding:0.533rem 0;
		border-bottom:1px solid #cccccc;
	}
	.answer-item:last-child{
		border-bottom:0;
	}
	.answer-avatar{
		float:left;
		overflow: hidden;
		width:1.2rem;
		height:1.2rem;
		border-radius: 50%;
	}
	.answer-content{
		float:right;
		width:7.733rem;
		padding-top:0.2rem;
	}
	.answer-name{
		font-size: 0.373rem;
		line-height: 0.373rem;
		color:#ec6d3a;
	}
	.answer-text{
		margin-top:0.173rem;
		font-size: 0.346rem;
		line-height:0.506rem;
	}
	.answer-info{
		margin-top:0.173rem;
		line-height: 0.346rem;
	}
	.answer-time{
		float:left;
		font-size: 0.266rem;
		color:#999;
	}
	.answer-button{
		float:right;
		font-size: 0.346rem;
		color:#3192e0;
	}
	.answer-reply{
		margin-top: 0.253rem;
		width:6.92rem;
		padding:0.173rem 0.4rem;
		background: #eee;
	}
	.answer-reply-item{
		color:#999;
		font-size: 0.346rem;
		line-height:0.506rem;
	}
	.answer-reply-item span{
		color:#666;
	}
	.reply-dialog{
		padding:0.506rem 0.4rem 0.4rem 0.4rem;
		width:8.4rem;
		background: #f3f3f3;
	}
	.reply-dialog-line{
		font-size: 0.346rem;
		line-height: 0.346rem;
	}
	.reply-dialog-text{
		float:left;
		color:#999;
	}
	.reply-dialog-close{
		float:right;
	}
	.reply-dialog-area{
		margin-top:0.293rem;
		text-align: center;
	}
	.reply-dialog-area textarea{
		box-sizing: border-box;
		padding:0.4rem;
		height:3.52rem;
		width:100%;
		border:1px solid #f3f3f3;
		background: #fff;
		border-radius: 0.133rem;
	}
	.reply-dialog-num{
		line-height:0.573rem;
		font-size: 0.346rem;
		text-align: right;
		color:#999;
	}
	.reply-dialog-button{
		text-align: center;
	}
	.reply-dialog-button button{
		width:4.533rem;
		height:1.093rem;
		background:#ec6d3a;
		font-size: 0.426rem;
		color:#fff;
		border-radius:0.133rem;
		border:0;
	}
</style>



// WEBPACK FOOTER //
// src/components/answer/answer.vue